<template>
	<div class="index">
		<van-nav-bar title="" left-text="" @click-left="toService" left-arrow fixed>
		  <template #title>
		    <div class="van-image" style="width: 90px;">
		    	<img src="img/logo.png" class="van-image__img" @error="handleImageError" 
					loading="eager" decoding="sync" fetchpriority="high">
			</div>
		  </template>
		  <template #left>
		    <van-icon name="chat-o" size="26" />
		  </template>
		</van-nav-bar>

		<div class="banner banners" style="margin-top: 5px;height: 10rem;" >
		<swiper class="swiper" :options="bannerSwiperOption">
		  <swiper-slide v-for="(v,key) in banners" :key="key">
				<a>
					<!-- 第一张banner使用eager加载，其他使用lazy -->
					<img class="banner_img"  :src="v.url" @error="handleImageError" :loading="key === 0 ? 'eager' : 'lazy'" 
						decoding="async" />
				</a>			      
		  </swiper-slide>
		</swiper>
		
	</div>
		<div class="item">
			<div class="title">
				<span class="animate__animated animate__fadeIn">
					HOT
					<i style="font-size: 14px;">
						{{$t('home.gonggao')}}
					</i>
				</span>
			</div>
			<div class="girl">
				<div>
					<ul class="gaoduan">
						<li v-for="(v,key) in osList" :key="key" @click="profile(v.id)" >
							<div class="image-wrapper">
								<img :src="v.image" alt="" @error="handleImageError" loading="lazy" 
									decoding="async" fetchpriority="low" />
							</div>
							<p>
								{{$t('person1')}}
							</p>
							<span>
								<i>
									{{$t('home.qgkf')}}
								</i>
							</span>
						</li>
					</ul>
					<ul class="gaoduan">
						<li v-for="(v,key) in jsList" :key="key" @click="profile(v.id)">
							<div class="image-wrapper">
								<img :src="v.image" alt="" @error="handleImageError" loading="lazy" 
									decoding="async" fetchpriority="low" />
							</div>
							<p>
								{{$t('person2')}}
							</p>
							<span>
								<i>
									{{$t('home.qgkf')}}
								</i>
							</span>
						</li>
						
					</ul>
				</div>
				<a @click="$router.push({path:'/Choose'});" >
					{{$t('common.more')}}
				</a>
			</div>
		</div>
		<div class="item">
			<div class="title">
				<span class="animate__animated animate__fadeIn">
					{{$t('home.hotgame')}}
				</span>
			</div>
			<ul class="list">
				<li  @click="toLottery(v.key,v.id)" v-for="(v,key) in gameitem" :key="key">
					<div class="image">
						<img class="animate__animated animate__flipInX" alt=""  :src="v.ico" @error="handleImageError" 
							loading="lazy" decoding="async" fetchpriority="low"></div>
					<p>
						{{v.name}}
					</p>
				</li>
				
			</ul>
		</div>
		<div class="item">
			<div class="title" style="padding-bottom: 10px;">
				<span class="animate__animated animate__fadeIn">
					{{$t('home.hotlist')}}
				</span>
			</div>
			<div class="tj">
				<ul>
					<li v-for="(v,key) in movielist_1" :key="key"  >
						<div class="left">
							<div style="display: flex; flex-direction: column;">
								<div class="image-wrapper">
									<img :src="v.image" alt="" @error="handleImageError" loading="lazy" 
										decoding="async" fetchpriority="low" />
								</div>
								<p style="margin-top: 6px;">
									{{v.class_name}}
								</p>
							</div>
							<span>
								<i>
									{{$t('home.gaoji')}}
								</i>
							</span>
						</div>
						<div class="right">
							<div class="title">
								<span>
									<span class="van-badge__wrapper van-icon" style="font-size: 13px;">
										<img class="van-icon__image" src="/img/vipu.png"></span>
									{{$t('home.smrz')}}
								</span>
								<span>
									<span class="van-badge__wrapper van-icon" style="font-size: 13px;">
										<img class="van-icon__image" src="/img/vipu.png"></span>
									{{$t('home.videorz')}}
								</span>
							</div>
							<div class="tips">
								<span v-for="(val,index) in v.tags_arr" :key="index"  >
									{{val}}
								</span>

							</div>
							<div class="sm">
								<p class="sf">
									{{$t('home.star')}}：
									<span v-for="(numa,indexs) in v.star" :key="indexs" ></span>

								</p>
								<div>
									{{$t('home.sg')}}: {{v.sg}}cm {{$t('home.xw')}}：{{v.sw}}{{$t('home.diqu')}}：{{v.class_name}}
								</div>
							</div>
							<div class="btn"  @click="profile(v.id)">
								{{$t('home.apply')}}
							</div>
						</div>
					</li>
				</ul>
			</div>
		</div>
		<div class="gundong" data-v-2c0cea1a="">
			<p data-v-2c0cea1a="">
				{{$t('home.ssxz')}} 
			</p>
			<swiper class="swipers" :options="vipSwiperOption">
			  <swiper-slide v-for="(v,key) in vip_list" :key="key" >
					{{v}} {{$t('home.joinvip')}} 
			  </swiper-slide>
			</swiper>
			
		</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      notice: "获取中......",
      banners: [],
      basicData:[],
      gameitem: [{},{},{},{}],
      movielist_0: [{},{},{},{}],
      movielist_1: [{},{},{},{},{},{},{},{}],
      vip_list: [],
      isLoading: false,
      movielistSwiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesPerGroup : 1,
      },
      bannerSwiperOption: {
        loop: true,
        speed:1000,
        autoplay:true
      },
	  vipSwiperOption: {
		direction: 'vertical',
		slidesPerView:7,
	    loop: true,
	    speed:1000,
	    autoplay:true
	  }
    };
  },
  computed: {
      osList() {
        return this.movielist_0.filter((item, index) => index % 2 === 0);
      },
	  jsList() {
	    return this.movielist_0.filter((item, index) => index % 2 === 1);
	  },
    },
  methods:{
    gotoMenu(router){
      this.$router.replace(router)
    },
    toLottery(key,id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/Lottery?key='+key+"&id="+id})
      }

    },
	profile(id) {
		this.$router.push({ path: '/profile?id=' + id  });
	},
	handleImageError(event) {
		// 处理图片加载错误，避免 HTTP/2 协议错误影响显示
		const img = event.target;
		// 设置默认占位图或隐藏图片
		img.style.display = 'none';
		// 可选：设置占位图
		// img.src = '/img/null.png';
	},
	toService(){
	  if(this.$store.getters.getBaseInfo.iskefu == 1){
	    this.$router.push("ServiceOnline");
	  }else {
	    this.$toast(this.$t('common.refresh'));
	  }
	},
    toPlayVideo(id){
      if(!localStorage.getItem('token')){
        this.$router.push({path:'/Login'})
      }else {
        this.$router.push({path:'/PlayVideo?id='+id})
      }
    },
    onRefresh() {
      setTimeout(() => {
        this.getBasicConfig();
        this.isLoading = false;
        this.$toast(this.$t('common.refresh'));
      }, 500);
    },
    getBasicConfig(){
      this.$http({
        method: 'get',
        url: 'sys_config'
      }).then(res=>{
        // 检查响应数据是否存在且没有错误
        if (res && res.data && !res.error) {
          this.basicData = res.data;
          // 安全访问属性，设置默认值
          this.vip_list = res.data.vip_list || [];
          this.getNotice(res.data);//获取公告
          this.getBanner(res.data);//获取banner
          this.getGameItem();//获取首页游戏列表
          this.getMovieList_0(res.data);//获取首页视频0
          this.getMovieList_1(res.data);//获取首页视频1
        } else {
          // 请求失败时使用默认值（静默处理）
          this.basicData = {};
          this.vip_list = [];
          this.banners = [];
          this.movielist_0 = [];
          this.movielist_1 = [];
          // 只在有明确错误消息时提示用户
          if (res && res.message) {
            this.$toast.fail(res.message || '网络请求失败');
          }
        }
      }).catch(err => {
        // 捕获错误，避免页面崩溃（静默处理）
        this.basicData = {};
        this.vip_list = [];
        this.banners = [];
        this.movielist_0 = [];
        this.movielist_1 = [];
        // 只在有明确错误消息时提示用户
        if (err && err.message) {
          this.$toast.fail(err.message || '网络请求失败');
        }
      })

    },
    getNotice(data){
      this.notice = (data && data.notice) || '暂无公告';
    },
    getGameItem(){
      this.$http({
        method: 'get',
        url: 'lottery_hot'
      }).then(res=>{
        if (res && res.data && !res.error) {
          this.gameitem = res.data || [];
        } else {
          this.gameitem = [];
        }
      }).catch(() => {
        // 静默处理错误
        this.gameitem = [];
      })
    },
    getMovieList_0(data){
      this.movielist_0 = (data && data.movielist_0) || [];
    },
    getMovieList_1(data){
      this.movielist_1 = (data && data.movielist_1) || [];
    },
    getBanner(data){
      this.banners = (data && data.banners) || [];
    }
  },
  mounted () {

  },
  created() {
    this.getBasicConfig();
  }
}

</script>

<style lang='less' scoped>
@import "../../assets/css/basenew.css";
.van-nav-bar {
    z-index: 999;
    position: absolute;
    background: url(/img/header.svg) no-repeat 50%/100%;
}

// 图片优化样式
.image-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s ease-in-out infinite;
}

@keyframes loading {
    0% {
        background-position: 200% 0;
    }
    100% {
        background-position: -200% 0;
    }
}

.image-wrapper img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: opacity 0.3s ease-in-out;
    opacity: 0;
}

.image-wrapper img[src] {
    opacity: 1;
}

.image-wrapper img[style*="display: none"] {
    opacity: 0;
}

.banner_img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    transition: opacity 0.3s ease-in-out;
    background-color: #f5f5f5;
}

.banner_img[style*="display: none"] {
    opacity: 0;
}

// 优化图片加载性能
img {
    display: block;
    max-width: 100%;
    height: auto;
    will-change: opacity;
}

// 懒加载优化
img[loading="lazy"] {
    background-color: #f5f5f5;
    content-visibility: auto;
}

// 图片加载完成前的占位效果
img:not([src]) {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
    animation: loading 1.5s ease-in-out infinite;
}
</style>
